import React from "react";
import NoteSearch from "./NoteSearch";

class NoteHeader extends React.Component {
  constructor(props) {
    super(props);

    this.onSearchValue = this.onSearchValue.bind(this);
  }

  onSearchValue(search) {
    this.props.searchNote(search);
  }

  render() {
    return (
      <div className="note-app__header">
        <h1>Notes</h1>
        <NoteSearch searchValue={this.onSearchValue} />
      </div>
    );
  }
}

export default NoteHeader;
